import React from 'react';
import { motion } from 'framer-motion';

const LINKS = [
  { name: 'Galaxia ID', href: process.env.REACT_APP_GALAXIA_ID_URL || 'https://galaxia-id.vercel.app' },
  { name: 'Portal', href: process.env.REACT_APP_GALAXIA_PORTAL_URL || 'https://galaxia-portal.vercel.app' },
  { name: 'TIN', href: 'https://galaxia-tin.vercel.app' },
  { name: 'SIN', href: 'https://galaxia-sin.vercel.app' },
  { name: 'AI Infra', href: 'https://galaxia-ai-testnet.vercel.app' },
  { name: 'Compliance', href: 'https://galaxia-compliance-testnet.vercel.app' },
  { name: 'GXAs', href: 'https://galaxia-gxas-testnet.vercel.app' }
];

/**
 * Ecosystem navigation — loose-coupled links to Galaxia Core apps.
 */
const EcosystemNav = () => (
  <motion.nav
    className="galaxia-card p-4"
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.2, delay: 0.05 }}
    aria-label="Galaxia ecosystem"
  >
    <p className="text-xs uppercase tracking-wider mb-3 text-galaxia-muted">Asset and avatar bridge</p>
    <div className="flex flex-wrap gap-2">
      {LINKS.map((link) => (
        <a
          key={link.name}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs px-3 py-1.5 rounded-lg transition-transform hover:scale-105"
          style={{
            border: '1px solid var(--galaxia-border)',
            color: 'var(--galaxia-accent)',
            background: 'rgba(206,147,216,0.08)'
          }}
        >
          {link.name}
        </a>
      ))}
    </div>
  </motion.nav>
);

export default EcosystemNav;
